import { get } from 'lodash';
import useConfirmTipTicket from 'modules/POS/PaymentDetails/ConfirmTipTicket';
import { useTicketWrapper } from 'modules/POS/Receipts/context';
import cashierService from 'modules/POS/services';
import cashierApis from 'modules/POS/services/apis';
import { IApiCashierPaymentBody } from 'modules/POS/services/types/payment';
import { IResponseData } from 'services/response';
import { useAppDispatch } from 'store/hooks';
import toast from 'utils/toast';
import { cashierCtrl } from '../../cashier.controller';
import { IUICashierFormValues } from '../../cashier.interface';
import CashierActionButton, { ActionType } from '../../components/CashierActionButton';
import { useSocketContext } from '../../hooks/useSocket';
import ModalCashPayment, { ICashierCashPaymentMethod, useModalCashPaymentRef } from './ModalCashPayment';
type Props = {
  cashIncentive?: IUICashierFormValues['cashIncentive'];
  cashIncentiveAmount?: IUICashierFormValues['cashIncentiveAmount'],
  enable?: IUICashierFormValues['cashIncentiveDiscount'],
};
const CashierCashPayment = ({ enable, cashIncentive, cashIncentiveAmount }: Props) => {
  const [completedTicketModalRef, completedTicketModalContext] = useConfirmTipTicket();
  const dispatch = useAppDispatch();
  const ref = useModalCashPaymentRef();
  const ticketContext = useTicketWrapper();
  const socketContext = useSocketContext();
  const onCash = () => cashierCtrl.saveTicketPaymentWithCallBack((billId) => {
    if (billId) ref.current?.open(billId);
  });

  const onPayment: ICashierCashPaymentMethod = async (billId, paymentItem) => {
    const body: IApiCashierPaymentBody = {
      billId, payments: [paymentItem],
    };
    try {
      const res: IResponseData<any> = await cashierApis.paymentTicket(body);
      if (res.data.data) {
        toast.success('Success');
        dispatch(cashierService.actions.async.lstBillOnHold.fetch());
        socketContext.alertPaymentSuccess(billId);
        const callback = () => {
          cashierCtrl.generateNewTicketAfterPayment();
        };
        if (!completedTicketModalRef.current) {
          ticketContext.completedTicket(billId, true);
          callback();
        } else {
          completedTicketModalRef.current.open(billId, callback);
        }
        return true;
      }
      throw res.data.data;
    } catch (error) {
      const msg = get(error, ['response', 'data', 'message'], 'Fail');
      toast.error(msg);
      return false;
    }
  };

  return (
    <>
      <CashierActionButton
        type={ActionType.CASH}
        onClick={onCash}
      />
      <ModalCashPayment ref={ref}
        cashIncentive={cashIncentive}
        cashIncentiveAmount={cashIncentiveAmount}
        enable={enable}
        onPayment={onPayment}
      />
      {completedTicketModalContext}
    </>
  );
};

export default CashierCashPayment;
